import { useEffect } from "react";
import { useSelector } from "react-redux";
import { configureCrisp } from "../utils/crisp";
import { getCrispWebsiteId } from "../selectors/configSelectors";

// Loads the Crisp widget on the logged-out checkout pages (courses/:id/checkout
// and courseOffers/:id). The lead's contact data (name/email/phone) is pushed to
// Crisp from the backend when the lead form is submitted (Lead after_commit ->
// SyncLeadDataWorker) — the trusted REST path. The chatbox identify is not used
// here because it left the contact named after the e-mail.
export default function useCrispCheckout() {
  const crispWebsiteId = useSelector(getCrispWebsiteId);

  useEffect(() => {
    if (crispWebsiteId) configureCrisp(crispWebsiteId);
  }, [crispWebsiteId]);
}
